module.exports = __webpack_public_path__ + "static/img/xuanzhongshiping.png@2x.6c1a807e.png";